/* ==========================================================================
   MAIRAZ SIZE CHART  -  assets/mairaz-size-chart.js
   --------------------------------------------------------------------------
   Unit switching for the shared Mairaz size chart
   (snippets/mairaz-size-chart.liquid).

   SINGLE SOURCE OF TRUTH
   The authoritative INCH value of every cell is written once by Liquid into
   the cell's data-mrz-in attribute and is never modified. Inches are shown by
   re-printing data-mrz-in; centimetres are CALCULATED from data-mrz-in every
   time they are displayed. Nothing is ever converted from an already
   converted number, so INCHES -> CM -> INCHES -> CM cannot drift.

   ROUNDING
   cm = inch * 2.54, displayed to one decimal place. Ties (a value that falls
   exactly halfway) are resolved half-to-even, which reproduces the approved
   centimetre reference set exactly (e.g. 22.5 in -> 57.1 cm, 37.5 in ->
   95.2 cm, 12.5 in -> 31.8 cm, 7.5 in -> 19.1 cm). The decimal expansion is
   read from the double with toFixed(15) so the tie test is exact and does not
   depend on a second floating-point multiplication.

   STORAGE
   localStorage key 'mairaz:size-chart-unit', values 'in' or 'cm'. No personal
   data. Every access is wrapped in try/catch, so the chart works normally in
   private mode or when storage is blocked; in that case each visit simply
   starts on INCHES.
   ========================================================================== */

(function () {
  if (window.MairazSizeChart) return;

  var STORAGE_KEY = 'mairaz:size-chart-unit';
  var DEFAULT_UNIT = 'in';
  var LABELS = { in: { word: 'inches', abbr: 'in', name: 'Inches' }, cm: { word: 'centimetres', abbr: 'cm', name: 'Centimetres' } };

  var current = null;

  /* ---- conversion ------------------------------------------------------ */

  function toCm(inch) {
    var v = inch * 2.54;
    var s = v.toFixed(15);
    var dot = s.indexOf('.');
    var whole = s.slice(0, dot);
    var frac = s.slice(dot + 1);
    var tenths = parseInt(whole, 10) * 10 + parseInt(frac.charAt(0), 10);
    var rest = frac.slice(1).replace(/0+$/, '');
    var up;
    if (rest === '') {
      up = false;
    } else if (rest === '5') {
      up = tenths % 2 !== 0; /* exact tie -> round half to even */
    } else {
      up = rest.charAt(0) >= '5';
    }
    if (up) tenths += 1;
    return (tenths / 10).toFixed(1);
  }

  function display(cell, unit) {
    var raw = cell.getAttribute('data-mrz-in');
    if (raw === null || raw === '') return;
    if (unit === 'cm') {
      var n = parseFloat(raw);
      cell.textContent = isNaN(n) ? raw : toCm(n);
    } else {
      cell.textContent = raw; /* the untouched authoritative inch value */
    }
  }

  /* ---- storage --------------------------------------------------------- */

  function readStored() {
    try {
      var v = window.localStorage.getItem(STORAGE_KEY);
      return v === 'cm' || v === 'in' ? v : null;
    } catch (e) {
      return null;
    }
  }

  function writeStored(unit) {
    try {
      window.localStorage.setItem(STORAGE_KEY, unit);
    } catch (e) {
      /* storage unavailable - the chart still works, it just will not remember */
    }
  }

  /* ---- rendering ------------------------------------------------------- */

  function roots() {
    return document.querySelectorAll('[data-mrz-sc]');
  }

  function paint(root, unit) {
    var i;
    var cells = root.querySelectorAll('[data-mrz-in]');
    for (i = 0; i < cells.length; i++) display(cells[i], unit);

    var words = root.querySelectorAll('[data-mrz-sc-word]');
    for (i = 0; i < words.length; i++) words[i].textContent = LABELS[unit].word;

    var abbrs = root.querySelectorAll('[data-mrz-sc-abbr]');
    for (i = 0; i < abbrs.length; i++) abbrs[i].textContent = LABELS[unit].abbr;

    var btns = root.querySelectorAll('[data-mrz-sc-unit-btn]');
    for (i = 0; i < btns.length; i++) {
      var on = btns[i].getAttribute('data-mrz-sc-unit-btn') === unit;
      btns[i].setAttribute('aria-checked', on ? 'true' : 'false');
      btns[i].setAttribute('tabindex', on ? '0' : '-1');
    }

    root.setAttribute('data-mrz-sc-unit', unit);
    hints(root);
  }

  function hints(root) {
    var wraps = root.querySelectorAll('[data-mrz-sc-scroll]');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      var scrolls = w.scrollWidth - w.clientWidth > 2;
      var hint = w.parentNode.querySelector('[data-mrz-sc-swipe]');
      if (hint) hint.hidden = !scrolls;
      if (scrolls) {
        w.setAttribute('tabindex', '0');
      } else {
        w.removeAttribute('tabindex');
      }
    }
  }

  function announce(unit) {
    var live = document.querySelectorAll('[data-mrz-sc-live]');
    for (var i = 0; i < live.length; i++) {
      live[i].textContent = 'Measurements now shown in ' + LABELS[unit].word + '.';
    }
  }

  function setUnit(unit, opts) {
    if (unit !== 'in' && unit !== 'cm') unit = DEFAULT_UNIT;
    current = unit;
    var list = roots();
    for (var i = 0; i < list.length; i++) paint(list[i], unit);
    if (!opts || opts.persist !== false) writeStored(unit);
    if (opts && opts.announce) announce(unit);
  }

  function init() {
    var list = roots();
    if (!list.length) return;
    if (current === null) current = readStored() || DEFAULT_UNIT;
    for (var i = 0; i < list.length; i++) paint(list[i], current);
  }

  /* ---- interaction (delegated, so late-rendered charts also work) ------ */

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var btn = event.target.closest('[data-mrz-sc-unit-btn]');
    if (!btn) return;
    event.preventDefault();
    var unit = btn.getAttribute('data-mrz-sc-unit-btn');
    if (unit === current) return;
    setUnit(unit, { announce: true });
    var again = btn.closest('[data-mrz-sc]');
    if (again) {
      var focus = again.querySelector('[data-mrz-sc-unit-btn="' + unit + '"]');
      if (focus) focus.focus();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!event.target || !event.target.closest) return;
    var btn = event.target.closest('[data-mrz-sc-unit-btn]');
    if (!btn) return;
    var key = event.key;
    var next = null;
    if (key === 'ArrowRight' || key === 'ArrowDown') next = 'cm';
    else if (key === 'ArrowLeft' || key === 'ArrowUp') next = 'in';
    else if (key === 'Home') next = 'in';
    else if (key === 'End') next = 'cm';
    else if (key === ' ' || key === 'Spacebar') next = btn.getAttribute('data-mrz-sc-unit-btn');
    if (!next) return;
    event.preventDefault();
    if (next !== current) setUnit(next, { announce: true });
    var group = btn.closest('[data-mrz-sc]');
    if (group) {
      var focus = group.querySelector('[data-mrz-sc-unit-btn="' + next + '"]');
      if (focus) focus.focus();
    }
  });

  /* ---- lifecycle ------------------------------------------------------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', function () {
    var list = roots();
    for (var i = 0; i < list.length; i++) hints(list[i]);
  });

  /* The product Size Guide panel is a native <dialog>; its contents are laid
     out only once it is shown, so re-measure the scroll hint when it opens. */
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    if (!event.target.closest('[data-mrz-sg-open]')) return;
    window.setTimeout(init, 0);
  });

  /* Theme editor re-renders a section without a page load. */
  document.addEventListener('shopify:section:load', init);

  window.MairazSizeChart = {
    init: init,
    refresh: init,
    toCm: toCm,
    setUnit: function (u) { setUnit(u, { announce: true }); },
    getUnit: function () { return current || DEFAULT_UNIT; },
    STORAGE_KEY: STORAGE_KEY
  };
})();
